import { useMemo } from 'react';
import { useIsDemo } from '@/hooks/common/useIsDemo';
import { useSelectedOrgId } from '@/hooks/common/useSelectedOrgId';
import { filterByOrg } from '@/mockData/common/demoFilters';
import { ALL_DEALS } from '@/mockData';
import { ARI_PIPELINE_DEALS, ARI_SUGGESTED_DEALS } from '@/mockData/ariPipeline';

export function useDealPipelineData() {
  const isDemo = useIsDemo();
  const selectedOrgId = useSelectedOrgId();

  const initialDeals = useMemo(
    () => (isDemo ? ARI_PIPELINE_DEALS : filterByOrg(ALL_DEALS, selectedOrgId)),
    [isDemo, selectedOrgId],
  );

  const suggestedDeals = useMemo(() => (isDemo ? ARI_SUGGESTED_DEALS : []), [isDemo]);

  return { initialDeals, suggestedDeals, isAriPipeline: isDemo };
}
